import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import {  useNavigate } from "react-router-dom";

import { getAttachmentsEmployes } from "../../../../../../MyApi/sb/employes";

import LoadingSpinner from "../../../../../UI/spinner";
import SingleEmployesAttachments from "./singleAttachments";

import icons from "../../../../../../Data/icons";
import classes from "./employes.module.css";
import EmployeAttachmentsModal from "./employeattachmentsmodal";

const EmployesAttachments = ({ id }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading ,refetch} = useQuery(["getEmployesAttachments", id], () =>
    getAttachmentsEmployes(id)
  );
  const [isModalOpen ,setIsModalOpen]=useState(false)
  const [ selectedRowId,setSelectedRowId] =useState("")
  const employesAttachments = data?.data || [];

  const AddIcon = icons.add;
  const openModal =(id)=>{
    setIsModalOpen(true)
    setSelectedRowId(id)
  }
  const closeModal =()=>{
    setIsModalOpen(false)
    setSelectedRowId("")
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data avalible</div>;
  }

  return (
    <div className="table-responsive p-2">
      <div className="p-2">
        <button
          className={classes.addBtn}
          onClick={() =>
            navigate(`${process.env.PUBLIC_URL}/employeattachmentsstore/${id}`)
          }>
          <AddIcon />
        </button>
      </div>

      <table className="table-responsive-sm table table-striped table-hover">
        <thead className="text-center">
          <th>#</th>
          <th>{t("Name")}</th>
          <th>{t("expired_at")}</th>
          <th>{t("status")}</th>
          <th>{t("actions")}</th>
        </thead>
        <tbody>
          {employesAttachments.map((employe) => (
            <SingleEmployesAttachments key={employe.id} {...employe}  openModal={openModal} closeModal={closeModal} isModalOpen={isModalOpen}/>
          ))}
        </tbody>
      </table>
      {isModalOpen && <EmployeAttachmentsModal  refetch={refetch} selectedRowId={selectedRowId} employesAttachments={employesAttachments}   closeModal={closeModal}/>}
    </div>
  );
};

export default EmployesAttachments;
